export default "__VITE_ASSET__CtW4L9Xm__"